import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { IUsuarioCambiarPasswordModel } from 'src/app/models/interfaces/seguridad/IUsuarioCambiarPasswordModel';
import { IUsuarioReestablecerPasswordModel } from 'src/app/models/interfaces/seguridad/IUsuarioReestablecerPasswordModel';
import { IUsuarioRegistrarModel } from 'src/app/models/interfaces/seguridad/IUsuarioRegistrarModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SeguridadUsuarioService {
  // private configUrl = 'api/usuarios';
  private configUrl = [environment.apiGatewayUrl, 'usuarios'].join('/');
  private configToExportUrl = [environment.apiGatewayUrl, 'usuarios', 'exportar'].join('/');
  private configContratistaUrl = [environment.apiSecurityContratistaUrl, 'usuarios'].join('/');
  private configContratistaIdentityUrl = [environment.apiSecurityContratistaUrl, 'identity'].join('/');

  constructor(private http: HttpClient) {}  

  getCurrent() : Observable<IUsuarioRegistrarModel> {
    return this.http.get<IUsuarioRegistrarModel>(`${this.configUrl}/current`);
  }

  getById(id: number) : Observable<IUsuarioRegistrarModel> {
    return this.http.get<IUsuarioRegistrarModel>(`${this.configUrl}/${id}`);
  }

  getList(filter: IFilterUsuarioModel) : Observable<SearchResultModel<UsuarioResultadoBusquedaModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${filter.page}`);
    queryParams.push(`take=${filter.pageSize}`);

    if (filter.idSede) {
      if(filter.idSede > 0){
        queryParams.push(`idSede=${filter.idSede}`);
      }
    }

    if (filter.idRol) {
      if(filter.idRol > 0){
        queryParams.push(`idRol=${filter.idRol}`);
      }
    }

    queryParams.push(`idTipoUsuario=${filter.idTipoUsuario}`);

    if(filter.idEstado > 0){
      queryParams.push(`idEstado=${filter.idEstado}`);
    }
    
    if (filter.usuario !== '') {
      queryParams.push(`usuario=${filter.usuario}`);
    }

    if (filter.correo !== '') {
      queryParams.push(`correo=${filter.correo}`);
    }

    
    if (filter.idCompania) {
      if(filter.idCompania > 0){
        queryParams.push(`idCompania=${filter.idCompania}`);
      }
    }

    return this.http.get<SearchResultModel<UsuarioResultadoBusquedaModel[]>>(this.configUrl + '?'+ queryParams.join('&'));
  }

  getListToExport(filter: IFilterUsuarioModel) : Observable<Blob> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${filter.page}`);
    queryParams.push(`take=${filter.pageSize}`);

    if (filter.idSede) {
      if(filter.idSede > 0){
        queryParams.push(`idSede=${filter.idSede}`);
      }
    }

    if (filter.idRol) {
      if(filter.idRol > 0){
        queryParams.push(`idRol=${filter.idRol}`);
      }
    }

    queryParams.push(`idTipoUsuario=${filter.idTipoUsuario}`);

    if(filter.idEstado > 0){
      queryParams.push(`idEstado=${filter.idEstado}`);
    }
    
    if (filter.usuario !== '') {
      queryParams.push(`usuario=${filter.usuario}`);
    }

    if (filter.correo !== '') {
      queryParams.push(`correo=${filter.correo}`);
    }

    return this.http.get(this.configToExportUrl + '?'+ queryParams.join('&'), { responseType: 'blob'});
  }

  submit(model: IUsuarioRegistrarModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  update(model: IUsuarioRegistrarModel) {
    return this.http.put<ActionResultModel>(`${this.configUrl}`, model);
  }

  delete(id: number) {
    return this.http.delete(`${this.configUrl}/${id}`);
  }

  disable(id: number) {
    return this.http.delete<ActionResultModel>(`${this.configUrl}/${id}/disable`);
  }

  cambiarPassword(model: IUsuarioCambiarPasswordModel) {
    return this.http.post<IUsuarioCambiarPasswordModel>(`${this.configContratistaUrl}/change-password`, model);
  }

  recuperarPassword(model: string) {
    return this.http.post<IUsuarioCambiarPasswordModel>(`${this.configContratistaIdentityUrl}/recover-password`, { email: model} );
  }

  reestablecerPassword(model: IUsuarioReestablecerPasswordModel){
    return this.http.post<IUsuarioReestablecerPasswordModel>(`${this.configContratistaIdentityUrl}/reset-password`, model );
  }

  verificarSiExiste(email: string) : Observable<boolean> {
    return this.http.get<boolean>(`${this.configUrl}/verificar-si-existe/${email}`);
  }
}
